export default __webpack_public_path__ + "static/media/alberi.663477d4.webp";